export const TAX_DISPLAY_MODES = [
    'excluding',
    'including',
    'noDisplay'
];
export const EXEMPTION_REASONS = [
    'nonprofit501c3',
    'governmentEntity',
    'tribalGovernment',
    'religiousOrganization',
    'educationalInstitution',
    'resaleCertificate',
    'directPayPermit',
    'outOfStatePurchaser',
    'other'
];
export const DEFAULT_CLIENT_TAX_SETTINGS = {
    taxExempt: false,
    ratePresetId: null,
    exemptReason: null,
    certificate: null
};
export const DEFAULT_SALES_TAX_CONFIG = {
    enabled: false,
    displayMode: 'excluding',
    label: 'Sales tax',
    presets: []
};
